import React from 'react';
import ChangePasswordSection from '../../../shared/components/auth/ChangePasswordSection';

function WorkerSettingsPage() {
  return <ChangePasswordSection />;
}

export default WorkerSettingsPage;
